import {
  createSlice,
} from '@reduxjs/toolkit';
import setEntitiesState, { setBaseState } from '../../store/utils/setStoreState';

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: {
    entities: {
      envParams: {},
      orderInfo: {},
      orderPaymentResult: {},
      userInfo: {},
    },
    defaultData: {},
  },
  reducers: {
    setEnvParams: setEntitiesState('envParams'),
    setOrderInfo: setEntitiesState('orderInfo'),
    setUserInfo: setEntitiesState('userInfo'),
    setOrderPaymentResult: setEntitiesState('orderPaymentResult'),
    setDefaultData: setBaseState('defaultData'),
  },
});

export const {
  setEnvParams, setOrderInfo, setOrderPaymentResult, setUserInfo, setDefaultData,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
